function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var LikeNotificationTemplate = require('./notification-like.template');
var ReplyNotificationTemplate = require('./notification-reply.template');
var saito = require('./../../../lib/saito/saito');
var Tweet = require('./tweet');
var SaitoUser = require('./../../../lib/saito/ui/saito-user/saito-user');
var Image = require('./image');
var RedSquareNotification = /*#__PURE__*/function () {
  function RedSquareNotification(app, mod) {
    var tx = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    _classCallCheck(this, RedSquareNotification);
    this.app = app;
    this.mod = mod;
    this.tx = tx;
    this.user = null;
  }
  return _createClass(RedSquareNotification, [{
    key: "render",
    value: function render() {
      var _this = this;
      var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (this.tx == null) {
        this.app.browser.addElementAfterSelector('<div class="saito-end-of-redsquare">no notifications</div>', selector);
      } else {
        var _txmsg$data, _txmsg$data2, _txmsg$data3;
        var _html = '';
        var txmsg = this.tx.returnMessage();
        if ((_txmsg$data = txmsg.data) !== null && _txmsg$data !== void 0 && (_txmsg$data = _txmsg$data.mentions) !== null && _txmsg$data !== void 0 && _txmsg$data.includes(this.mod.publicKey) || ((_txmsg$data2 = txmsg.data) === null || _txmsg$data2 === void 0 ? void 0 : _txmsg$data2.mentions) == 1) {
          this.renderNotificationTweet(txmsg, this.tx);
          return;
        }

        //
        // The tx_sig of the tweet that is being liked or replied to...
        this.signature = ((_txmsg$data3 = txmsg.data) === null || _txmsg$data3 === void 0 ? void 0 : _txmsg$data3.signature) || txmsg.data.parent_id || null;

        //
        // We put the entire render in a callback so that if we don't have the original tweet being referenced by the
        // notification, we can make a peer DB request to try to find it
        //
        if (this.signature) {
          this.mod.loadTweetWithSig(this.signature, function (txs) {
            if (!txs) {
              console.warn('RS.Notification for unknown tweet');
              return null;
            }
            var tweet_tx;
            if (Array.isArray(txs)) {
              if (txs.length > 0) {
                tweet_tx = txs[0];
              } else {
                console.warn('RS.Notification for unknown tweet');
                return null;
              }
            } else {
              tweet_tx = txs;
            }
            _this.renderNotificationTweet(txmsg, tweet_tx);
          });
        } else {
          console.log('RS.notification ... unexpected notification type..');
          this.renderNotificationTweet(txmsg, this.tx);
        }
      }
    }
  }, {
    key: "renderNotificationTweet",
    value: function renderNotificationTweet(txmsg, tweet_tx) {
      var _txmsg$data4, _txmsg$data5;
      if ((_txmsg$data4 = txmsg.data) !== null && _txmsg$data4 !== void 0 && (_txmsg$data4 = _txmsg$data4.mentions) !== null && _txmsg$data4 !== void 0 && _txmsg$data4.includes(this.mod.publicKey) || ((_txmsg$data5 = txmsg.data) === null || _txmsg$data5 === void 0 ? void 0 : _txmsg$data5.mentions) == 1) {
        this.tweet = new Tweet(this.app, this.mod, tweet_tx);
      } else {
        var _this$tweet, _txmsg$data6;
        if (txmsg.request == 'like tweet' || txmsg.request == 'retweet') {
          //Process as normal
          var keyword = txmsg.request == 'like tweet' ? 'liked' : 'retweeted';
          this.tweet = new Tweet(this.app, this.mod, tweet_tx, ".tweet-notif-fav.notification-item-".concat(this.tx.from[0].publicKey, "-").concat(this.signature, " .tweet-body .tweet-main .tweet-preview"));
          this.user = new SaitoUser(this.app, this.mod, ".notification-item-".concat(this.tx.from[0].publicKey, "-").concat(this.signature, " > .tweet-header"), this.tx.from[0].publicKey);
          var qs = ".tweet-notif-fav.notification-item-".concat(this.tx.from[0].publicKey, "-").concat(this.signature);
          var obj = document.querySelector(qs);
          if (obj) {
            obj.innerHTML = obj.innerHTML.replace("".concat(keyword, " "), "really ".concat(keyword, " "));

            //We process multiple likes from same person of same tweet, just update html in situ and quit
            return;
          } else {
            html = LikeNotificationTemplate(this.app, this.mod, this.tx);
            var msg = "".concat(keyword, " your tweet");
            if (this.mod.publicKey != tweet_tx.from[0].publicKey) {
              msg = "".concat(keyword, " a tweet sent to you");
            }
            this.user.notice = "</i> <span class='notification-type'>".concat(msg, "</span>");
          }
        } else if (txmsg.request == 'create tweet') {
          this.tweet = new Tweet(this.app, this.mod, tweet_tx, ".notification-item-".concat(this.tx.signature, " .tweet-body .tweet-main .tweet-preview"));
          this.user = new SaitoUser(this.app, this.mod, ".notification-item-".concat(this.tx.signature, " > .tweet-header"), this.tx.from[0].publicKey);
          html = ReplyNotificationTemplate(this.app, this.mod, this.tx);

          //
          // retweet
          //
          if (txmsg.data.retweet_tx) {
            var _msg = 'retweeted your tweet';
            if (this.mod.publicKey != tweet_tx.from[0].publicKey) {
              _msg = 'retweeted a tweet concerning you';
            }
            this.user.notice = "<span class='notification-type'>".concat(_msg, "</span>");

            //
            // or reply
            //
          } else {
            var _msg2 = 'replied to your tweet';
            if (this.mod.publicKey !== tweet_tx.from[0].publicKey) {
              _msg2 = 'replied to a tweet concerning you';
            }
            this.user.notice = "<span class='notification-type'>".concat(_msg2, "</span>");
          }
        } else {
          console.warn('RS.Notification: Unknown type -- ', txmsg.request);
          return null;
        }
        if (!((_this$tweet = this.tweet) !== null && _this$tweet !== void 0 && _this$tweet.noerrors)) {
          return null;
        }

        //
        //
        //
        var nqs = '.notification-item-' + this.tx.signature;
        if (document.querySelector(nqs)) {
          this.app.browser.replaceElementBySelector(html, nqs);
        } else {
          this.app.browser.addElementToSelector(html, '.tweet-container');
        }

        //
        // and render the user
        //
        if (new Date().getTime() - this.tx.timestamp > 24 * 60 * 60 * 100) {
          this.user.fourthelem = "<div class=\"timestamp\">".concat(this.app.browser.prettifyTimeStamp(this.tx.timestamp, true), "</div>");
        } else {
          this.user.fourthelem = "<div class=\"timestamp\">".concat(this.app.browser.returnTime(this.tx.timestamp), "</div>");
        }
        this.user.render();

        // check and render images if any in notification
        if ((_txmsg$data6 = txmsg.data) !== null && _txmsg$data6 !== void 0 && _txmsg$data6.images) {
          var _txmsg$data7;
          var img_preview = new Image(this.app, this.mod, ".notification-item-".concat(this.tx.signature, " .tweet-body .tweet-main .notification-tweet"), (_txmsg$data7 = txmsg.data) === null || _txmsg$data7 === void 0 ? void 0 : _txmsg$data7.images, tweet_tx.signature);
          img_preview.render();
        }
      }
      this.tweet.show_controls = 0;
      this.tweet.render();
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      Array.from(document.querySelectorAll('.tweet')).forEach(function (obj) {
        obj.onclick = function (e) {
          var sig = e.currentTarget.getAttribute('data-id');
          var tweet = _this2.mod.returnTweet(sig);
          if (tweet) {
            _this2.app.connection.emit('redsquare-tweet-render-request', tweet);
          } else {
            //
            // I'm not sure we would ever run into this situation
            // Besides wounldn't the this.tweet be the one we are looking for... why even go through the DOM dataset?
            //
            console.warn('RS.Notification tweet not found...');
            _this2.mod.loadTweetWithSig(sig, function (txs) {
              var tweet = _this2.mod.returnTweet(sig);
              _this2.app.connection.emit('redsquare-tweet-render-request', tweet);
            });
          }
        };
      });
    }
  }, {
    key: "isRendered",
    value: function isRendered() {
      //if (document.querySelector(`.notification-item-${this.tx.signature}`)) {
      //  return true;
      //}
      return false;
    }
  }]);
}();
module.exports = RedSquareNotification;